import { GraphQLClient } from 'graphql-request';

const endpoint = {
  production: 'https://ipa.elev.io/grappa/public/graphql',
};

export const elevioPublicGqlClient: GraphQLClient = new GraphQLClient(
  endpoint.production,
);
